import { Platform } from 'react-native';

type NativeAgentDebugCounter = 'parsedEvents' | 'adapterYields' | 'threadUpdates';

type NativeAgentDebugState = Record<NativeAgentDebugCounter, number>;

declare global {
  // eslint-disable-next-line no-var
  var __tabbioNativeAgentDebugState: NativeAgentDebugState | undefined;
}

const INITIAL_DEBUG_STATE: NativeAgentDebugState = {
  parsedEvents: 0,
  adapterYields: 0,
  threadUpdates: 0,
};

function isEnabled() {
  return __DEV__ && Platform.OS !== 'web';
}

function getState(): NativeAgentDebugState {
  if (!globalThis.__tabbioNativeAgentDebugState) {
    globalThis.__tabbioNativeAgentDebugState = { ...INITIAL_DEBUG_STATE };
  }

  return globalThis.__tabbioNativeAgentDebugState;
}

export function resetNativeAgentDebug(reason: string) {
  if (!isEnabled()) return;
  globalThis.__tabbioNativeAgentDebugState = { ...INITIAL_DEBUG_STATE };
  console.log('[native-chat][debug][reset]', { reason, platform: Platform.OS });
}

export function bumpNativeAgentDebugCounter(
  counter: NativeAgentDebugCounter,
  payload?: Record<string, unknown>,
) {
  if (!isEnabled()) return 0;

  const state = getState();
  state[counter] += 1;

  console.log(`[native-chat][debug][${counter}]`, {
    count: state[counter],
    ...payload,
  });

  return state[counter];
}

export function logNativeAgentDebug(
  scope: string,
  payload?: Record<string, unknown>,
) {
  if (!isEnabled()) return;
  console.log(`[native-chat][debug][${scope}]`, payload ?? {});
}
